import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../../../services/api.service';
import { Router } from '@angular/router';
import { FormControl, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-aggiungi-configurazione-backoffice',
  templateUrl: './aggiungi-configurazione-backoffice.component.html',
  styleUrl: './aggiungi-configurazione-backoffice.component.css'
})
export class AggiungiConfigurazioneBackofficeComponent implements OnInit {

  constructor(private apiService: ApiService, private router: Router) { }

  formConfigurazione!: FormGroup;

  ngOnInit(): void {

    this.formConfigurazione = new FormGroup({
      value: new FormControl(null, Validators.required),
      descrizione: new FormControl(null)
    })

  }

  onSubmit() {

    let configurazione = {
      value: this.formConfigurazione.get('value')?.value,
      descrizione: this.formConfigurazione.get('descrizione')?.value
    }

    this.apiService.addConfigurazione(configurazione).subscribe({
      next: (data) => this.apiService.setConfigurazioni(),
      error: (err) => this.apiService.message('error', 'Errore', err.error.message.message),
      complete: () => {
        this.router.navigate(['/backoffice/configurazioni'])
      }
    })

  }

}
